(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarRequestsController', WebinarRequestsController);

    WebinarRequestsController.$inject = ['WebinarService','$uibModal', 'FileUploader'];


    function WebinarRequestsController(WebinarService,$uibModal, FileUploader) {
        var vm = this;


        vm.flag                 = false;
        vm.webinarSelected      = '';
        vm.clientName           = '';
        vm.webinarTitle         = '';

        vm.selectWebinars       = selectWebinars;
        vm.getByFilter          = getByFilter;
        vm.seeDetails           = seeDetails;
        vm.hideWebinar          = hideWebinar;
        vm.showWebinar          = showWebinar;
        vm.approveWebinar       = approveWebinar;
        vm.disapproveWebinar    = disapproveWebinar;
        vm.editWebinar          = editWebinar;
        vm.deleteWebinar        = deleteWebinar;
        vm.importAttendees      = importAttendees;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function activate() {
            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectWebinars () {
            WebinarService.selectWebinars().then(function(response){
                vm.webinars = response;
                vm.webinars.unshift({id:0,title:"All"});
            }).catch(function(err) {

            });
        }

        function getByFilter () {
            vm.flag         = false;
            vm.query        = {};
            // if( vm.webinarSelected.id && vm.webinarSelected.id > 0) {
            //     vm.query['webinar']   = vm.webinarSelected.id;
            // }
            if( vm.clientName && vm.clientName !== '') {
                vm.query['client_name'] = vm.clientName;
            }
            if( vm.webinarTitle && vm.webinarTitle !== '') {
                vm.query['webinar_title'] = vm.webinarTitle;
            }
            vm.query['page'] = vm.page;
            WebinarService.getWebinarRequests(vm.query).then(function(response){
                vm.webinarResponse  = response.data;
                vm.users            = response.data.users;
                vm.flag             = true;
                vm.totalItems       = response.data.total;
                vm.to               = response.data.to;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {

            });
        }

        function seeDetails(webinar)
        {
            $uibModal.open({
                templateUrl: 'templates/webinar/reports/requests/details/webinarRequestDetails.html',
                controller: 'WebinarRequestDetailsController',
                controllerAs:'vm',
                resolve:
                    {
                        webinarItem      : function () {
                            return webinar;
                        }
                    }
            });
        }

        function importAttendees(webinar)
        {
            $uibModal.open({
                templateUrl: 'templates/webinar/reports/requests/attendees/webinarRequestAttendees.html',
                controller: 'WebinarRequestAttendeesController',
                controllerAs:'vm',
                resolve:
                    {
                        webinarItem      : function () {
                            return webinar;
                        }
                    }
            });
        }

        function hideWebinar(user)
        {
            alertify
                .confirm('This action is reversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to HIDE this webinar?')
                .set('onok', function (){
                    WebinarService.hide(user.webinar.id).then(function() {
                        vm.users[user.profile.id].webinar.can_show = 0;
                        alertify.notify('Webinar updated', 'success', 3);
                    });
                })
                .show();
        }

        function showWebinar(user)
        {
            alertify
                .confirm('This action is reversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to SHOW this webinar?')
                .set('onok', function (){
                    WebinarService.show(user.webinar.id).then(function() {
                        vm.users[user.profile.id].webinar.can_show = 1;
                        alertify.notify('Webinar updated', 'success', 3);
                    });
                })
                .show();
        }

        function approveWebinar(user)
        {
            alertify
                .confirm('This action is reversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to APPROVE this webinar?')
                .set('onok', function (){
                    WebinarService.approve(user.webinar.id).then(function() {
                        vm.users[user.profile.id].webinar.status.name = 'Approved';
                        vm.users[user.profile.id].webinar.status.class = 'success';
                        alertify.notify('Webinar updated', 'success', 3);
                    });
                })
                .show();
        }

        function disapproveWebinar(user)
        {
            alertify
                .confirm('This action is reversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to REJECT this webinar?')
                .set('onok', function (){
                    WebinarService.disapprove(user.webinar.id).then(function() {
                        vm.users[user.profile.id].webinar.status.name = 'Rejected';
                        vm.users[user.profile.id].webinar.status.class = 'danger';
                        alertify.notify('Webinar updated', 'success', 3);
                    });
                })
                .show();
        }

        function editWebinar(webinar)
        {
            $uibModal.open({
                templateUrl: 'templates/webinar/reports/requests/edit/webinarRequestEdit.html',
                controller: 'WebinarRequestEditController',
                controllerAs:'vm',
                size: 'lg',
                resolve:
                    {
                        webinarItem     : function () {
                            return webinar;
                        },
                        webinarResponse : function () {
                            return vm.webinarResponse;
                        }
                    }
            });
        }

        function deleteWebinar(user)
        {
            alertify
                .confirm('This action is not reversible!')
                .set('labels', {
                    ok: 'Yes',
                    cancel: 'No'
                })
                .set('title', 'Do you really want to DELETE this webinar?')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['id'] = user.webinar.id;
                    WebinarService.deleteWebinar(vm.query).then(function() {
                        delete vm.users[user.profile.id];
                        vm.to = vm.to - 1;
                        vm.totalItems = vm.totalItems - 1;
                        alertify.notify('Webinar deleted', 'success', 3);
                    });
                })
                .show();
        }

        activate();
    }

})();